import _ from 'lodash';

const state = JSON.stringify({
  shop: _.first(window.location.host.split('.')),
  'redirect-url': window.location.href,
});

export const socialProviders = {
  facebook: {
    name: 'facebook',
    clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
    redirectUri: `${process.env.VUE_APP_BASE_API_URL}auth/facebook`,
    requiredUrlParams: ['scope', 'state'],
    scope: ['email'],
    scopeDelimiter: ',',
    display: 'popup',
    oauthType: '2.0',
    popupOptions: {width: 580, height: 400},
    state,
  },
  google: {
    name: 'google',
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
    redirectUri: `${process.env.VUE_APP_BASE_API_URL}auth/google`,
    requiredUrlParams: ['scope', 'state'],
    optionalUrlParams: ['display'],
    scope: ['profile', 'email'],
    scopePrefix: 'openid',
    scopeDelimiter: ' ',
    display: 'popup',
    oauthType: '2.0',
    popupOptions: {width: 452, height: 633},
    state,
  },
};